import React from 'react';
import VideoItem from '../../shared/components/VideoItem';
import { StyleSheet, css } from 'aphrodite/no-important';
import { widthRange } from '../../shared/constants';
import { media } from '../../shared/styles/constants';
import {constants} from '../constants';

const cssMediaItemSettingsLeft = {
	desktop: { item: { width: '100%' }},
	laptop: { item: { width: '460px' }},
	tablet: { item: { width: '347px' }},
	mobile: { item: { width: '100%' }}
};

const cssMediaItemSettingsRight = {
	desktop: { item: { width: '260px' }},
	laptop: { item: { width: '300px' }},
	tablet: { item: { width: '223px' }},
	mobile: { item: { width: '46%' }}
};

class EightItems extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			leftContainerPosts: [],
			rightContainerPosts: this.props.posts.slice(0, 8),
			currentWidthRange: widthRange.DESKTOP_MOBILE
		}
	}

	organizeContainers(){
		if (!window) {
			return;
		}

		let width = window.innerWidth;

		if (width >= 1280 || width <= 767) {
			if (this.state.currentWidthRange === widthRange.DESKTOP_MOBILE) {
				return;
			}

			this.setState(() => ({
				leftContainerPosts: [],
				rightContainerPosts: this.props.posts,
				currentWidthRange: widthRange.DESKTOP_MOBILE
			}));

			return;
		}

		if (this.state.currentWidthRange === widthRange.tabletLaptop) {
			return;
		}

		this.setState(() => ({
			leftContainerPosts: this.props.posts.slice(0, 2),
			rightContainerPosts: this.props.posts.slice(2, 8),
			currentWidthRange: widthRange.tabletLaptop
		}));
	}

	componentDidMount() {
		this.organizeContainers();

		if (window){
			window.addEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	componentWillUnmount() {
		if (window){
			window.removeEventListener("resize", this.organizeContainers.bind(this));
		}
	}

	render() {
		const leftPosts = this.state.leftContainerPosts;
		const rightPosts = this.state.rightContainerPosts;
		let outerIndex = 0;
		let utmObj = this.props.utmObj || {};
		let key = 1;

		return (
			<div className={css(this.props.containerStyle)}>
				{leftPosts.length > 0 &&
					<div className={css(styles.container)}>
						{leftPosts.map(p => (
							<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsLeft} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />
						))}
					</div>
				}
				<div className={css(styles.container)}>
					{rightPosts.map(p => (
						<VideoItem post={p} key={key++} mediaSettings={cssMediaItemSettingsRight} outerIndex={outerIndex++} utmObj={utmObj} classPostfix={constants.VC_CLASS_POSTFIX} />
					))}
				</div>
			</div>
		);
	}
}

export default EightItems;

const styles = StyleSheet.create({
	container: {
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'space-between',
		width: '100%',

		[media.MOBILE]: {
			justifyContent: 'space-around'
		}
	}
});



// WEBPACK FOOTER //
// ./react-app-src/videoCollections/components/EightItems.js